var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrepaidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5647 8.58601C13.3675 8.38887 13.0479 8.38887 12.8508 8.58601L11.0923 10.3444L10.4877 9.73985C10.2906 9.54271 9.97097 9.54271 9.77383 9.73985C9.57669 9.93699 9.57669 10.2566 9.77383 10.4538L10.7354 11.4153C10.9325 11.6124 11.2521 11.6124 11.4493 11.4153L13.5647 9.29991C13.7618 9.10277 13.7618 8.78315 13.5647 8.58601Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.835938 5.56788C0.835938 4.33413 1.83609 3.33398 3.06983 3.33398H16.9354C18.1691 3.33398 19.1693 4.33413 19.1693 5.56788V14.8116C19.1693 16.0453 18.1691 17.0455 16.9354 17.0455H3.06983C1.83609 17.0455 0.835938 16.0453 0.835938 14.8116V5.56788ZM3.06983 4.72054C2.60186 4.72054 2.22249 5.09991 2.22249 5.56788V9.33397H7.55565C7.87473 7.34968 9.59499 5.83396 11.6693 5.83396C13.7435 5.83396 15.4638 7.34968 15.7829 9.33397H17.7827V5.56788C17.7827 5.09991 17.4033 4.72054 16.9354 4.72054H3.06983ZM2.22249 14.8116V10.6673H7.55565C7.87475 12.6516 9.595 14.1673 11.6693 14.1673C13.7435 14.1673 15.4638 12.6516 15.7829 10.6673H17.7827V14.8116C17.7827 15.2795 17.4033 15.6589 16.9354 15.6589H3.06983C2.60186 15.6589 2.22249 15.2795 2.22249 14.8116ZM14.5026 10.0006C14.5026 11.5654 13.2341 12.834 11.6693 12.834C10.1045 12.834 8.83594 11.5654 8.83594 10.0006C8.83594 8.43582 10.1045 7.16729 11.6693 7.16729C13.2341 7.16729 14.5026 8.43582 14.5026 10.0006Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepaidIcon);
export default __webpack_public_path__ + "static/media/prepaid-icon.c2085acb35af2ff62f8e6896ec8e46b4.svg";
export { ForwardRef as ReactComponent };